import { Builder } from '@builder.io/sdk';
import { HubNewsCarousel, HUB_NEWS_CAROUSEL_NAME } from './HubNewsCarousel';
import { BuilderInputOptions } from '@/types/builder';

const HubNewsCarouselConfig = {
  name: HUB_NEWS_CAROUSEL_NAME,
  friendlyName: 'Hub News Carousel',
  description:
    'A horizontal carousel of news article cards with background images, titles, and dates. Shows 4 cards on desktop, 2 on mobile with left/right navigation arrows.',
  inputs: [
    {
      name: 'title',
      type: 'richText',
      friendlyName: 'Heading',
      defaultValue: 'Catch up on the latest <span style="color: #FE5000;">[HUB NAME]</span> news...',
      helperText:
        'The section heading. Use rich text to colour the hub name orange — select the hub name text and set its colour to #FE5000.',
    },
    {
      name: 'autoSelectLatest',
      type: 'boolean',
      friendlyName: 'Auto-select latest articles',
      helperText:
        'When on, automatically shows the most recent articles. Turn off to hand-pick specific articles for the carousel.',
      defaultValue: true,
    },
    {
      name: 'limit',
      type: 'number',
      friendlyName: 'Number of articles',
      helperText: 'How many article cards to include in the carousel. Default: 8.',
      defaultValue: 8,
      min: 2,
      max: 20,
      showIf: (options: BuilderInputOptions) => options?.get('autoSelectLatest') !== false,
    },
    {
      name: 'articles',
      type: 'list',
      friendlyName: 'Articles',
      helperText: 'Pick which articles appear in the carousel. Order here = order in the carousel.',
      showIf: (options: BuilderInputOptions) => options?.get('autoSelectLatest') === false,
      subFields: [
        {
          name: 'article',
          type: 'reference',
          model: 'article',
        },
      ],
    },
  ],
};

Builder.registerComponent(HubNewsCarousel, HubNewsCarouselConfig);
